import styled from "styled-components";

/**
 * Wrapper principal do filtro de aeroportos.
 */
export const AirportsFilterWrapper = styled.div`
  gap: ${({ theme }) => theme.spacing(3)};
  flex-direction: column;
  display: flex;
  width: 100%;
`;

/**
 * Lista de aeroportos filtrados.
 */
export const AirportsListWrapper = styled.div`
  gap: ${({ theme }) => theme.spacing(2)};
  flex-direction: column;
  display: flex;
`;

/**
 * Item individual na lista de aeroportos.
 */
export const AirportItem = styled.div`
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  display: flex;
`;
